import React from 'react';

// Shared confirmation dialog — replaces the browser's native window.confirm()
// with something that matches the rest of the app's styling.
export default function ConfirmModal({ open, title, message, confirmLabel, cancelLabel, danger, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', backdropFilter: 'blur(6px)',
    }}>
      <div style={{
        background: 'white', borderRadius: 24, width: '100%', maxWidth: 420, padding: '2rem',
        boxShadow: '0 30px 80px rgba(0,0,0,0.25)',
      }}>
        <h5 style={{ fontWeight: 900, marginBottom: '1rem', color: danger ? '#dc2626' : 'var(--navy)' }}>{title}</h5>
        <p style={{ color: 'var(--muted)', fontWeight: 600, whiteSpace: 'pre-line', marginBottom: '1.75rem', lineHeight: 1.5 }}>
          {message}
        </p>
        <div className="d-flex gap-2">
          <button className="btn-outline-summer flex-fill" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            className="btn-summer flex-fill"
            style={danger ? { background: 'linear-gradient(135deg, #ef4444, #dc2626)' } : undefined}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
